/**
 * /settings — layout that hosts settings sub-pages.
 *
 * Renders nothing of its own; just an <Outlet /> so child routes can
 * mount. The actual /settings page (API keys / secrets management)
 * lives in _auth.settings.index.tsx; sibling pages like
 * _auth.settings.entities.tsx render inside the same layout.
 *
 * Why split this way: TanStack Router treats `_auth.settings.entities.tsx`
 * as a CHILD of `_auth.settings.tsx`. If the parent has its own
 * component without an Outlet, navigating to /settings/entities
 * silently rendered the parent (the secrets page) instead of the
 * child (entities admin). Splitting into layout + .index is the
 * standard fix.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  return <Outlet />;
}
